





























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import SearchComponent from "@/components/structure/Search.vue";
import { Getter } from "vuex-class";
import * as types from "@/store/types";
import AuthService from "@/services/api/auth.service";
import { CurrentUser } from "@/models/auth/current.user";
import { UserBadge } from "@/models/users/user.badge";
import { LayoutServiceBus } from "@/services/bus/layout.service";
import { UserMenu } from "@/models/menus/menu";
import { ActivityAreaDto, UserDto } from "@/server/app.dtos";

@Component({
  components: {
    Search: SearchComponent
  }
})
export default class HeaderComponent extends Vue {
  @Getter("identity") user!: CurrentUser;
  @Getter("profile") profile!: UserDto;
  @Getter("activityAreas") areas!: ActivityAreaDto[];
  @Watch("profile")
  onProfileChanged(): void {
    this.loadUserBadge();
  }
  userBadge: UserBadge = new UserBadge();
  authService: AuthService = new AuthService();
  quickCreateMenu: boolean = false;
  userMenu: boolean = false;
  languageMenu: boolean = false;
  userMenus: UserMenu = new UserMenu();

  created() {
    this.loadUserBadge();
  }

  loadUserBadge(): void {
    if (this.profile) {
      this.userBadge.idUser = this.profile.idUser || 0;
      this.userBadge.name = this.profile.name || "";
      this.userBadge.photo = this.profile.photo || null;
    }
  }

  changeLanguage(lang: string): void {
    this.$i18n.locale = lang;
  }

  logout(): void {
    this.$store.dispatch(types.LOGOUT);
    this.authService.Logout();
    this.$router.replace("/login");
  }

  addActivity(area: ActivityAreaDto): void {
    this.quickCreateMenu = false;
    LayoutServiceBus.openSideMenuCreatingActivity(area);
  }

  openNotifications(): void {
    LayoutServiceBus.openNotifications();
  }
}
